import { http } from "../api/http";
import { ApplicationPaths } from "@arelia-components/api-authorization/AuthConstants";
import { useQuery } from "react-query";
import { Account } from "../types";

export default function useAuth(): Account {
  const query = useQuery(`/api/account`, async () => {
    const resp = await http(`/api/account`, { responseType: "response" });
    if (resp.ok) {
      return await resp.json();
    } else if (resp.status === 401) {
      const returnUrl = window.location.href.replace(window.location.origin, "");
      navigateTo(`${ApplicationPaths.Login}?returnUrl=${encodeURIComponent(returnUrl)}`);
    } else if (resp.status === 404) {
      navigateTo('/');
    }

    return null;
  });

  return query.data;
}

export function navigateTo(url: string) {
  window.location.href = url;
}